import {
  Datatype,
  IReference,
  ReferencePathDirection,
  ReferenceType,
} from '@framework/engine';
import { ISiapUserData, THEME_SIAP_KEY } from './useThemeValidationContext';

function createSiapReference(
  datatype: Datatype.String | Datatype.Number | Datatype.Date,
  code: string,
  label: string,
  field: keyof ISiapUserData,
): IReference {
  return {
    type: ReferenceType.Session,
    id: `siap_${field}_${code}`,
    code,
    label,
    path: [
      { direction: ReferencePathDirection.Absolute, code: 'session' },
      { direction: ReferencePathDirection.Child, code: THEME_SIAP_KEY },
      { direction: ReferencePathDirection.Child, code: field },
    ],
    field: {
      type: datatype,
    },
    group: 'SIAP: Dati Dipendente',
  };
}

/**
 * Verificare sempre che siano allineate con `ISessionData`.
 * Il prefisso è sempre `session`
 */
export function getThemeDataReferences(): IReference[] {
  return [
    // Anagrafica
    createSiapReference(Datatype.String, 'cognome', 'Cognome dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'nome', 'Nome dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataNascita', 'Data di nascita dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'comuneNascita', 'Comune di nascita dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'provinciaNascita', 'Provincia di nascita dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'statoNascita', 'Stato di nascita dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'codiceFiscale', 'Codice fiscale dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'sesso', 'Sesso dipendente', 'anagrafica'), // prettier-ignore
    createSiapReference(Datatype.String, 'statoServizio', 'Stato di servizio dipendente', 'anagrafica'), // prettier-ignore

    // Assunzione
    createSiapReference(Datatype.String, 'tipoRapportoAssunzione', 'Tipo rapporto assunzione', 'assunzione'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio assunzione', 'assunzione'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine assunzione', 'assunzione'), // prettier-ignore
    createSiapReference(Datatype.String, 'motivoAssunzione', 'Motivo assunzione', 'assunzione'), // prettier-ignore
    createSiapReference(Datatype.String, 'specificaAssunzione', 'Specifica assunzione', 'assunzione'), // prettier-ignore

    // Profilo
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataEconomica', 'Data economica profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.String, 'denominazioneProfilo', 'Denominazione profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.String, 'areaProfilo', 'Area profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.String, 'fasciaProfilo', 'Fascia profilo', 'profilo'), // prettier-ignore
    createSiapReference(Datatype.String, 'specificaProfilo', 'Specifica profilo', 'profilo'), // prettier-ignore

    // Assegnazione
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio assegnazione', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataPresaServizio', 'Data presa servizio assegnazione', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine assegnazione', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'codAooIstituto', 'Codice AOO istituto', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'denominazioneIstituto', 'Denominazione istituto', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'sedeServizioIstituto', 'Sede servizio istituto', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'specifica', 'Specifica assegnazione', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'comuneIstituto', 'Comune istituto', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'provinciaIstituto', 'Provincia istituto', 'assegnazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'regioneIstituto', 'Regione istituto', 'assegnazione'), // prettier-ignore

    // Incarico dirigenziale
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataPresaServizio', 'Data presa servizio incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'codAooIstituto', 'Codice AOO istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'denominazioneIstituto', 'Denominazione istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'sedeServizioIstituto', 'Sede servizio istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'specifica', 'Specifica incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'comuneIstituto', 'Comune istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'provinciaIstituto', 'Provincia istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore
    createSiapReference(Datatype.String, 'regioneIstituto', 'Regione istituto incarico dirigenziale', 'incaricoDirigenziale'), // prettier-ignore

    // Distacco
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataPresaServizio', 'Data presa servizio distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'codAooIstituto', 'Codice AOO istituto distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'denominazioneIstituto', 'Denominazione istituto distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'sedeServizioIstituto', 'Sede servizio istituto distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'specifica', 'Specifica distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'comuneIstituto', 'Comune istituto distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'provinciaIstituto', 'Provincia istituto distacco', 'distacco'), // prettier-ignore
    createSiapReference(Datatype.String, 'regioneIstituto', 'Regione istituto distacco', 'distacco'), // prettier-ignore

    // Comando out
    createSiapReference(Datatype.Date, 'dataInizio', 'Data inizio comando out', 'comandoOut'), // prettier-ignore
    createSiapReference(Datatype.Date, 'dataFine', 'Data fine comando out', 'comandoOut'), // prettier-ignore
    createSiapReference(Datatype.String, 'sedeComandoOut', 'Sede comando out', 'comandoOut'), // prettier-ignore

    // Cessazione
    createSiapReference(Datatype.Date, 'dataCessazione', 'Data cessazione', 'cessazione'), // prettier-ignore
    createSiapReference(Datatype.String, 'motivoCessazione', 'Motivo cessazione', 'cessazione'), // prettier-ignore
  ];
}
